import waves from './waves'
import permission from './permission'
import tableReachBottomScroll from './tableReachBottomScroll'

export default {
    install(Vue){
        Vue.directive('waves', waves)
        Vue.directive('permission', permission)
        Vue.directive('table-reach-bottom', tableReachBottomScroll)
    }
}


// WEBPACK FOOTER //
// ./src/directives/index.js